export function resizeCanvas(
  imageHeight: number,
  imageWidth: number,
  canvasHeight: number,
  canvasWidth: number
): { newImgHeight: number; newImgWidht: number } {
  const hightFactor = canvasHeight / imageHeight;
  const widthFactor = canvasWidth / imageWidth;
  let newImgHeight: number;
  let newImgWidht: number;
  // heights is smaller
  if (hightFactor < 1) {
    newImgHeight = imageHeight * hightFactor;
    newImgWidht = imageWidth * hightFactor;
  }
  // width is smaller
  if (widthFactor < 1) {
    newImgHeight = imageHeight * widthFactor;
    newImgWidht = imageWidth * widthFactor;
  }
  // screen is bigger than picture
  if (widthFactor >= 1 && hightFactor >= 1) {
    newImgHeight = imageHeight;
    newImgWidht = imageWidth;
  }
  newImgHeight = Number(newImgHeight.toFixed(0)) - 1;
  newImgWidht = Number(newImgWidht.toFixed(0)) - 1;
  return {
    newImgHeight,
    newImgWidht,
  };
}
